// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2vuS8","author":"Table_author__jVQNg","authorImage":"Table_authorImage__30oVL","unreadRow":"Table_unreadRow__2MezG"};